import React from "react";

import { StatementList } from "components/Statements/StatementList";

const StatementListPage = () => {
  return <StatementList />;
};
export default StatementListPage;
